import type { ServiceResponse } from "../core/service";
import type {
  TransactionGetListRequest,
  TransactionGetListResponse,
} from "../schemas/transaction";

import { BaseService } from "../core/service";
import { transactionGetListResponseSchema } from "../schemas/transaction";

export class TransactionService extends BaseService {
  public async getAll(
    data: TransactionGetListRequest,
  ): Promise<ServiceResponse<TransactionGetListResponse>> {
    return this.get("/transactions", {
      data,
      responseSchema: transactionGetListResponseSchema,
    });
  }
}
